var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bookingItemPricing),function(item){return _c('div',{key:item.label,staticClass:"mt-4"},[_c('DetailsCollapse',{attrs:{"is-open":false,"is-loading":_vm.isFetching,"label":item.label,"elements":item.dataItems}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }